module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-5.58819cec.jpg";